import useSWR from 'swr'

import { fetcher } from './fetcher'

/**
 * Dados da solicitação de autorização OAuth, para a tela de consentimento.
 *
 * O endpoint é anônimo de propósito: a tela precisa se desenhar antes do login,
 * para o usuário ver o que está autorizando antes de digitar a senha. O
 * `request_id` já é um segredo de 32 bytes, e a resposta não revela nada do
 * usuário.
 */

export interface OAuthClientI {
  client_id: string,
  client_name: string | null,
  client_uri: string | null,
  logo_uri: string | null,
  /** host de retorno; é o dado que o usuário consegue conferir */
  redirect_host: string | null,
  /** true só quando alguém da empresa revisou e aprovou o app */
  name_verified: boolean,
}

export interface OAuthScopeI {
  id: string,
  name: string,
  description: string | null,
}

export interface OAuthConsentRequestI {
  request_id: string,
  status: string,
  expires_in: number,
  client: OAuthClientI,
  resource: { uri: string, name: string },
  scopes: Array<OAuthScopeI>,
}

interface ReturnI {
  data: OAuthConsentRequestI | null,
  isLoading: boolean,
  isError: any,
}

const useOAuthConsentRequest = (requestId?: string | null) : ReturnI => {
  const { data, error } = useSWR<OAuthConsentRequestI>(
    requestId ? `oauth/authorize/request/${requestId}` : null,
    fetcher('GET'),
    // a solicitação é imutável enquanto vive; revalidar não traria nada
    { refreshInterval: 0, revalidateOnFocus: false, shouldRetryOnError: false }
  )

  return {
    data: data ?? null,
    isLoading: !!requestId && !error && !data,
    isError: error
  }
}

export default useOAuthConsentRequest
